import { UseCase } from 'src/app/core/utils/usecase';
import { Failure } from 'src/app/core/utils/failure';
import { Injectable } from '@angular/core';
import { ClaimColectiveRepositoryBase } from '../repositories/cliam-colective-base.repository';
import { ClaimCollectiveModel } from '../../data/models/claim-colective.model';
import { ClaimMultiRepositoryBase } from '../repositories/claim-multi-base.repository';
import { ClaimMultiModel } from '../../data/models/claim-multi.model';

@Injectable()
export class UpdateClaimMultiUseCase
  implements UseCase<ClaimMultiModel, string | Failure>
{
  constructor(private claimRepository: ClaimMultiRepositoryBase) {}

  async execute(param: ClaimMultiModel): Promise<string | Failure> {
    return await this.claimRepository.updateClaim(param);
  }
}
